export default "__VITE_ASSET__CZqa104y__"